<template>
  <span>
    <slot :click="openModal">
      <v-btn @click="openModal">Delete Image</v-btn>
    </slot>
    <v-dialog v-if="showDialog" v-model="showDialog" max-width="500px" persistent>
      <v-card class="pa-4">
        <v-card-title class="px-4">
            <h2 class="title">Delete Image</h2>
        </v-card-title>
        <div class="py-4 px-6">
          <v-alert class="pa-2 mt-0" outlined color="error" icon="error">
            <div class="text-body-2" style="color: #000000DE;">Are you sure you want to delete this Image?</div>
          </v-alert>
          <v-alert class="pa-2 mt-4" :value="!serverValidation" outlined color="error" icon="priority_high" transition="scale-transition">
            <span class="caption">{{ serverValidationMessage }}</span>
          </v-alert>
        </div>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="closeModal">Cancel</v-btn>
            <v-btn color="primary" :loading="saveLoading" :disabled="saveLoading" @click="saveChanges">Delete Anyway</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import EventBus from "@/main"
import ApiService from "@/common/api.service"

export default {
  name: 'DeleteImage',
  data() {
    return {
      no_data: [null, "", undefined, "null"],
      preparedData: {},
      saveLoading: false,
      showDialog: false,
      serverValidation: true,
      serverValidationMessage: "Oops something went wrong...",
      server_errors: {}
    }
  },
  methods: {
    openModal(item) {
      this.showDialog = true
      this.saveLoading = false
      this.preparedData = _.cloneDeep(item)
      this.resetServerValidation();
    },
    saveChanges() {
      this.resetServerValidation()
      this.saveLoading = true
      ApiService.delete(`/gotpooperscoopers/image/${this.preparedData.id}`)
        .then(response => {
          this.saveLoading = false;
          EventBus.$emit("notification", {
            status: "success",
            text: "Image has been successfully deleted."
          });
          this.$emit('done')
          this.closeModal()
        })
        .catch(({ response }) => {
          this.saveLoading = false;
          this.serverValidation = false;
          if (response.data.error) {
            this.serverValidationMessage = this.titleCase(response.data.error);
          }
          if (response.data.message) {
            this.serverValidationMessage = response.data.message;
          }
          if (response.data.errors) {
            if (typeof response.data.errors === "string") {
              this.serverValidationMessage = response.data.errors;
            } else {
              this.server_errors = response.data.errors;
            }
          }
        });
    },
    closeModal() {
      this.showDialog = false
    },
    resetServerValidation() {
      this.serverValidation = true;
      this.serverValidationMessage = "Oops something went wrong...";
      this.server_errors = {};
    }
  },
}
</script>